module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_menu_motivo_1 copy.61e8cac8.png";